export default __webpack_public_path__ + "media/images/edit-group-895f0e5ca4cef4bcbf476d5966b8f7dd.png";